import React, { useContext } from 'react';
import classNames from 'classnames';
import { mergeRefs } from '../../utils/mergeRefs.js';
import { DropdownContext } from './Dropdown.js';
import { useHasFocus } from '../../hooks/useHasFocus.js';
import { jsx } from '@emotion/react';
import '@indeed/downshift';
import '../../utils/isFunction.js';
import 'react-fast-compare';
import '../../constants/index.js';
import '@indeed/ihl-use-id';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';

const DropdownTarget = _ref => {
  let {
    children
  } = _ref;
  const {
    disabled,
    isOpen,
    targetRef,
    toggleButtonProps
  } = useContext(DropdownContext);
  const {
    ref: toggleRef,
    ...toggleProps
  } = toggleButtonProps;
  const hasFocus = useHasFocus(targetRef);
  if (typeof children === "string") {
    children = jsx("span", null, children);
  }
  const {
    ref = null,
    props: {
      className
    } = {}
  } = children;
  const classes = classNames(className, {
    "focus-within": hasFocus,
    "is-open": isOpen
  });
  return /*#__PURE__*/React.cloneElement(children, {
    ref: mergeRefs(ref, targetRef, toggleRef),
    className: classes,
    role: "button",
    tabIndex: disabled ? -1 : 0,
    ...toggleProps
  });
};
DropdownTarget.displayName = "DropdownTarget";

export { DropdownTarget };
